'use client'

import { ReactNode, useEffect, useState } from 'react'

import { Modal, ModalDescription, ModalTitle } from 'shared/ui/Modal'

import useCartStore from '../../../store/cartStore'

import UnavailableItemsResolver from './UnavailableItemsResolver'

import styles from './SubstitutesModal.module.scss'

type SubstitutesModalProps = {
  trigger?: ReactNode
  modalOpenTrigger?: number
}

const SubstitutesModal = ({
  trigger,
  modalOpenTrigger = 0
}: SubstitutesModalProps) => {
  const [open, setOpen] = useState<boolean>(false)
  const { productsNotAvailable } = useCartStore()

  useEffect(() => {
    modalOpenTrigger > 0 && setOpen(true)
  }, [modalOpenTrigger])

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <div className={styles.triggerWrapper} onClick={handleOpen}>
        {trigger}
      </div>
      <Modal id='product-replacements-modal' onClose={handleClose} open={open}>
        <ModalTitle>Zamienniki</ModalTitle>
        <ModalDescription>
          Przykro nam, ale niektóre produkty w Twoim koszyku nie są obecnie
          dostępne. Wymień niedostępne produkty aby otrzymać zamówienie w
          aktualnie wybranym terminie.
        </ModalDescription>

        <div className={styles.title}>
          Wymień lub usuń produkt (1 z {productsNotAvailable.length})
        </div>
        <hr className={styles.hr} />
        <UnavailableItemsResolver
          handleClose={handleClose}
          productsNotAvailable={productsNotAvailable}
        />
      </Modal>
    </>
  )
}

export default SubstitutesModal
